import { GraphQLTaggedNode } from 'relay-runtime';
import { useReadFragmentInterop } from './useReadFragmentInterop';
import { FragmentRef } from './useFragmentizedQuery';

export const useFragmentizedFragment = <TFragmentData>(
	fragmentNode: GraphQLTaggedNode,
	fragmentRef: FragmentRef,
): TFragmentData => {
	const readFragmentInterop = useReadFragmentInterop<TFragmentData>({
		fragmentSpec: fragmentNode,
	});

	return readFragmentInterop({
		id: `${fragmentRef?.__typename}:${fragmentRef?.id}`,
	}) as TFragmentData;
};
